import { BandScale } from './BandScale';
import { NumberCoercible } from './NumberCoercible';
import { StringCoercible } from './StringCoercible';
import { SupportedScale } from './SupportedScale';

export const isBandScale = <T extends StringCoercible | NumberCoercible = StringCoercible>(
  scale: SupportedScale<T>,
): scale is BandScale<T> => {
  return 'bandwidth' in scale;
};
